import { convertPattern, ConvertPatternError } from "../pattern/convertPattern";
import { Pattern } from "../pattern/pattern";
import { PhonemeInfo } from "../pattern/phonemeInfo";
import { IpaType } from "../phonemes/ipa";

/** a rule for figuring out which syllable to put the stress on */
export interface StressRule<T> {
  /** if no rule applies, this is the syllable to add stress to (negative numbers count from the end) */
  readonly default: number;
  /** try the matches one at a time, till a match is found or none are */
  readonly toCheck?: StressMatch<T>[];
  /** move pre-existing stress markers */
  readonly move?: 'beforeVowel';
}

export interface StressMatch<T> {
  /** which syllable to add stress to (negative numbers count from the end) */
  readonly which: number;
  /** if the word matches this pattern, put the stress on the 'which' syllable */
  readonly pattern: Pattern<T>;
}

export function compileStressRule(rule: StressRule<IpaType>): StressRule<PhonemeInfo> | ConvertPatternError[] {
  const errors: ConvertPatternError[] = [];
  const rules = rule.toCheck?.map(r => {
    const result = convertPattern(r.pattern);
    if (result.errors.length > 0) {
      errors.push(...result.errors);
    }
    return { which: r.which, pattern: result.pattern };
  });
  return { default: rule.default, toCheck: rules, move: rule.move };
}
